import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/baivong/Code/de4js/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/css/style.css",
    "revision": "a6289c3765438ab486bb87f2939a2790"
  },
  {
    "url": "assets/images/bkg.png",
    "revision": "360842dce3f69f728aa77ae005424fe8"
  },
  {
    "url": "assets/images/blacktocat.png",
    "revision": "63f291a3168cc5e02daaa6156756b122"
  },
  {
    "url": "assets/images/bullet.png",
    "revision": "03ac3148397e2db4a517b649dda1473b"
  },
  {
    "url": "assets/images/buttons/copy-document.png",
    "revision": "383595543e61ac2796b290749fcc52ef"
  },
  {
    "url": "assets/images/buttons/download.png",
    "revision": "d2dedf6d77957db5a7bfb6a53295e7d6"
  },
  {
    "url": "assets/images/buttons/external-link-symbol.png",
    "revision": "2de11a499c90ac4ae01e216b1f80177b"
  },
  {
    "url": "assets/images/icons/icon-128x128.png",
    "revision": "6f14d711cf80097b078497193ea4ac30"
  },
  {
    "url": "assets/images/icons/icon-144x144.png",
    "revision": "e67b5b9ba8858a5d7db314fb36c038a5"
  },
  {
    "url": "assets/images/icons/icon-152x152.png",
    "revision": "4ced623ede1d3cf81710a7e19037a2f7"
  },
  {
    "url": "assets/images/icons/icon-192x192.png",
    "revision": "f1b40ddd6aef720f988681573c295218"
  },
  {
    "url": "assets/images/icons/icon-384x384.png",
    "revision": "5ba82586ea5c9a813117f132eb348fe7"
  },
  {
    "url": "assets/images/icons/icon-512x512.png",
    "revision": "e6bdac56bd1b6144f2a134d5828b1f87"
  },
  {
    "url": "assets/images/icons/icon-72x72.png",
    "revision": "f2e958dff8f4adead85d6d2ed4691807"
  },
  {
    "url": "assets/images/icons/icon-96x96.png",
    "revision": "515f261f32a0fd0e6a1bc6487a377979"
  },
  {
    "url": "favicon.ico",
    "revision": "9023cfc9b056b1e214bed25cfc018a33"
  },
  {
    "url": "index.html",
    "revision": "e0f649af269de370edb8f66830a506cf"
  },
  {
    "url": "lib/arraydecode.js",
    "revision": "68512e5b55e2c08676f42807928315e2"
  },
  {
    "url": "lib/cleansource.js",
    "revision": "0d2627fe2a363b3fc880fd33611db090"
  },
  {
    "url": "lib/evaldecode.js",
    "revision": "ed14919cf01e5c67802fc4f72d6a682f"
  },
  {
    "url": "lib/jsfuckdecode.js",
    "revision": "7fe99e9044d95fde7ee9ec0df51b8882"
  },
  {
    "url": "lib/numberdecode.js",
    "revision": "9b100f205b5ed0b77c3a8196034e1d09"
  },
  {
    "url": "lib/obfuscatorio.js",
    "revision": "f8cfb122fa62dcb7447555f79db9b9bc"
  },
  {
    "url": "lib/utils.js",
    "revision": "cadd9aedeef5181271190fb46afad569"
  },
  {
    "url": "main.js",
    "revision": "ed18257e5e597f24e4323bce37913f9a"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "b94102b1340367613a5b168b57ba94d3"
  },
  {
    "url": "sw.js",
    "revision": "13fa1f655d857a184434c9ceb83274c6"
  },
  {
    "url": "third_party/cat-in-136/aadecode.js",
    "revision": "06ea6b7f3cc57abf9bf111be19f10c7c"
  },
  {
    "url": "third_party/clipboard-js/clipboard.min.js",
    "revision": "aeaeb6ab463cb8140a72103aedb01d74"
  },
  {
    "url": "third_party/decoder-jjencode/jjdecode.js",
    "revision": "27abc7cdeee1be4a891678eb72c46880"
  },
  {
    "url": "third_party/highlight-js/highlight.min.js",
    "revision": "9a99fc600014ee54d144c4e643fdfb05"
  },
  {
    "url": "third_party/js-beautify/beautify.min.js",
    "revision": "62a28a3187b18814899cf0813a718cb2"
  },
  {
    "url": "third_party/js-beautify/unpackers/javascriptobfuscator_unpacker.js",
    "revision": "939ead8257cdb38a0556ba8a0f79feda"
  },
  {
    "url": "third_party/js-beautify/unpackers/myobfuscate_unpacker.js",
    "revision": "9c2d3d994e406d3ca73419978ccfff26"
  },
  {
    "url": "third_party/js-beautify/unpackers/p_a_c_k_e_r_unpacker.js",
    "revision": "0303e930789facfc4d8a764ffcfb6d30"
  },
  {
    "url": "third_party/js-beautify/unpackers/urlencode_unpacker.js",
    "revision": "6c4a9f54d4a766f6d085fff7bd7c88fb"
  },
  {
    "url": "third_party/mathjs/math.min.js",
    "revision": "b5d0fab60a09c4aee005deba57498470"
  },
  {
    "url": "third_party/NotSoWise/notsowise.js",
    "revision": "258619740b05d48da4fb57de4208ca81"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-background-sync.dev.js",
    "revision": "292540f6dfbf73613fee69c4daa34768"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-background-sync.prod.js",
    "revision": "1477337d11af8f727e9203690ef10cfc"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-broadcast-update.dev.js",
    "revision": "c8aec116b72d5a6f4fbdf895cbe9a6a2"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-broadcast-update.prod.js",
    "revision": "3b28d76111687065750273c7ac7f4c97"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-cacheable-response.dev.js",
    "revision": "22b01a882fa59ca2dc95581a863d6543"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-cacheable-response.prod.js",
    "revision": "baa5a06eb89620c714728d9292895824"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-core.dev.js",
    "revision": "4da76fb060d4145b55f770ef2ba1916e"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-core.prod.js",
    "revision": "2002e39bc413245e9466646856a3a1a0"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-expiration.dev.js",
    "revision": "2b6ecefe6b4de33b232b1d4f3f6f2d4d"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-expiration.prod.js",
    "revision": "3c39521fc764b9952c819c8be6bdee40"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-navigation-preload.dev.js",
    "revision": "79bf2718a2ad92bc4b16e90df9a6813e"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-navigation-preload.prod.js",
    "revision": "b08e45df331d747386f7a9d3ce8d6f35"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-offline-ga.dev.js",
    "revision": "3bfac87afd96631ca169f1580340bb09"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-offline-ga.prod.js",
    "revision": "291d35c6a2d5e4e63240804f3da93dff"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-precaching.dev.js",
    "revision": "fe30d3ca56741cc350362b551cc81ea6"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-precaching.prod.js",
    "revision": "aad79f6fd69e76afce9a9bc0444fb4b1"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-range-requests.dev.js",
    "revision": "0aba977d2b293ce947ace319edfff93f"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-range-requests.prod.js",
    "revision": "05a4f56357fc7bc48478d8048df4f0e3"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-routing.dev.js",
    "revision": "eb2ee6155e0c721707d9fa05e4590f28"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-routing.prod.js",
    "revision": "65baaf497738a14f1b694a9cff829d4d"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-strategies.dev.js",
    "revision": "929f436eeb0effe772037b7afb8ab1db"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-strategies.prod.js",
    "revision": "2a12ac7e1932c797cb3084c2543066c9"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-streams.dev.js",
    "revision": "1ebc21ea730f92a3ea3e2698f9449a65"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-streams.prod.js",
    "revision": "e1ce8b87604c3265fcca4504f1b97814"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-sw.js",
    "revision": "dc277aae8a000c27df99aba092aa1832"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-window.dev.umd.js",
    "revision": "80d6025c59787e3fbdbd4e55ef08d7f3"
  },
  {
    "url": "third_party/workbox/workbox-v5.1.4/workbox-window.prod.umd.js",
    "revision": "a416894a85a10c88abd525b50d27ffed"
  },
  {
    "url": "userscript/de4js_helper.meta.js",
    "revision": "eafa1ca3bcac1b7e1fb3978853051544"
  },
  {
    "url": "userscript/de4js_helper.user.js",
    "revision": "6a5cc00a9a74ee9c8d50c4b615eef052"
  },
  {
    "url": "workbox-a82ab0ba.js",
    "revision": "b2f1b8a1271c7a1fc759abacf420d082"
  },
  {
    "url": "workbox-e1834b40.js",
    "revision": "c07d9aae0fac68e4354b6fe1087e0db2"
  },
  {
    "url": "worker/decode.js",
    "revision": "b53f449db555ab87b03988d69ede2526"
  },
  {
    "url": "worker/format.js",
    "revision": "23b47ac7fc78e5f145bb937a16e26387"
  }
], {});








